<template>
    <!-- TODO: REMOVE if when ok -->
    <landing v-if="userData && userData.is_staff">
        <v-container>
            <v-row>
                <v-col cols="12">
                    <div
                        :class="{
                            'display-3': $vuetify.breakpoint.mdAndUp,
                            'display-2': $vuetify.breakpoint.smAndDown,
                        }"
                        class="font-weight-bold pb-12"
                    >
                        ¿Qué desea hacer?
                    </div>
                    
                    <v-row class="mt-12 pt-12">
                        <v-col cols="6">
                            <v-btn
                                :disabled="false"
                                block
                                color="secondary"
                                x-large
                                @click="$router.push('create_contract')"
                            >
                                Contratar un nuevo contrato
                            </v-btn>
                        </v-col>
                        <v-col cols="6">
                            <v-btn
                                :disabled="false"
                                block
                                color="secondary"
                                x-large
                                @click="$router.push('upgrade_contract')"
                            >
                                Ampliar el contrato actual
                            </v-btn>
                        </v-col>
                    </v-row>

                </v-col>
            </v-row>
        </v-container>
    </landing>
</template>

<script>
    import Landing from "@/components/layout/Landing";
    import { mapGetters } from "vuex";

    export default {
        name: "CreateNewContract",
        components: {
            Landing,
        },
        computed: {
            ...mapGetters({
                userData: "me/userData",
            }),
        }
    }
</script>
